<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import dayjs from "dayjs";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "suggestions",
      key: "id",
      url: {
        get: "/admin/system/suggestions/getInfo",
        add: "/admin/system/suggestions/add",
        edit: "/admin/system/suggestions/edit",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "科室信息",
          name: "deskId",
          value: "",
          type: "select",
          width: "400px",
          rules: [{ required: true }],
          dropList: [],
        },
        {
          label: "问题描述",
          name: "problemDescription",
          value: "",
          type: "textarea",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "改善建议",
          name: "suggestionsImprovement",
          value: "",
          type: "textarea",
          width: "400px",
        },
        // {
        //   label: "经济效益",
        //   name: "economicBenefits",
        //   value: "",
        //   type: "textarea",
        //   width: "400px",
        // },
        {
          label: "关联工单",
          name: "workIdT",
          value: "",
          type: "multiple",
          width: "400px",
          dropList: [],
          onChange: this.onOperationRooms,
        },
      ],
      forms: {
        workId:""
      },
    };
  },
  async created() {
    let query = this.$route.query;
    if (query.action == "edit"){
      this.initData()
      // await this.getData(query.kv)
    }
await this.deskListMethod()
await this.workListMethod()
  },
  mounted() {
  },
  methods: {
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/suggestions/getInfo/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          let deskId = res.data.workId.split(",");
          this.forms.workIdT = deskId.map(Number);
        }
      });
    },
    onOperationRooms(val) {
      let ass = val.join(",");
      this.forms.workId = ass;
    },
    // async getData(id){
    //   let q = {
    //     id
    //   }
    //   let res = await $utils.api.load("/admin/system/suggestions/getInfo",q,"get");
    //   this.forms = res.data
    //
    // },
    async workListMethod() {
      let beginDay = dayjs().startOf("date").format("YYYY-MM-DD HH:mm:ss");
      let end = new Date()
      end = dayjs(end).format('YYYY-MM-DD HH:mm:ss')
      let q={
        begin : beginDay,
        end,
        state:3
      }

      let res = await $utils.api.load("/admin/system/work/list",q,"get");
      if (res && res.rows) {
        let ll = res.rows;

        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          let workInfotemp = "";
          if (element.workNo !== null && element.workNo !== undefined) {
            workInfotemp = element.workNo;
          }
          if (element.descr !== null && element.descr !== undefined) {
            let arr = element.descr.split(']')
            workInfotemp = workInfotemp + "/" + arr[1];
          }
          // if (element.phone !== null && element.phone !== undefined) {
          //   workInfotemp = workInfotemp +  "/" + element.phone ;
          // }
          // if (element.address !== null && element.address !== "") {
          //   workInfotemp = workInfotemp +  "/" + element.address;
          // }
          xx.name = workInfotemp;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "workIdT") {
            this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
            ).concat(dropList);
          }
        }
      }
    },
    async deskListMethod() {
      let res = await $utils.api.load("/admin/system/desk/selectList");
      if (res && res.rows) {
        let ll = res.rows;

        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          let workInfotemp = "";
          if (element.deskName !== null && element.deskName !== undefined) {
            workInfotemp = element.deskName;
          }
          if (element.principal !== null && element.principal !== undefined) {
            workInfotemp = workInfotemp + "/" + element.principal;
          }
          if (element.phone !== null && element.phone !== undefined) {
            workInfotemp = workInfotemp +  "/" + element.phone ;
          }
          if (element.address !== null && element.address !== "") {
            workInfotemp = workInfotemp +  "/" + element.address;
          }
          xx.name = workInfotemp;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "deskId") {
            this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
            ).concat(dropList);
          }
        }
      }
    },
  },
};
</script>
